{********************************************************************}
{                                                                    } 
{ written by TMS Software                                            }
{            copyright (c) 2016 - 2021                               }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCEditorsToolsUI;

{$I WEBLib.TMSFNCDefines.inc}
{$IFDEF LCLLIB}
  {$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
  {$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF VCLLIB}
  {$DEFINE FMXVCLLIB}
{$ENDIF}
{$IFDEF FMXLIB}
  {$DEFINE FMXVCLLIB}
{$ENDIF}
interface

uses
  Classes, Types, WEBLib.TMSFNCTypes, WEBLib.TMSFNCGraphicsTypes, WEBLib.Graphics,
  WEBLib.TMSFNCEditorsTools, WEBLib.TMSFNCToolBar, WEBLib.TMSFNCHTMLText, WEBLib.TMSFNCSplitter,
  WEBLib.TMSFNCPageControl, WEBLib.TMSFNCTabSet, WEBLib.TMSFNCCheckBox, WEBLib.TMSFNCGrid
  {$IFDEF WEBLIB}
  ,JS, Web
  {$ENDIF}
  {$IFNDEF LCLWEBLIB}
  {$HINTS OFF}
  {$IF COMPILERVERSION > 22}
  ,UITypes
  {$IFEND}
  {$HINTS ON}
  ,Generics.Collections
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fgl, LCLType, LCLIntF
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : First Release

procedure SetEditorHTMLTextAppearance(AHTMLText: TTMSFNCHTMLText; AFontColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR; ABackGroundColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR);
procedure SetEditorToolBarAppearance(AToolBar: TTMSFNCToolBar; APrimaryColor: TTMSFNCGraphicsColor = EDITORPRIMCOLOR; ARounding: integer = EDITORBUTTONROUNDING; AFontColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR; ABackGroundColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR);
procedure SetEditorToolBarButtonAppearance(AButton: TTMSFNCToolBarButton; APrimaryColor: TTMSFNCGraphicsColor = EDITORPRIMCOLOR; ARounding: integer = EDITORBUTTONROUNDING; AFontColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR; ABackGroundColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR);
procedure SetEditorFNCSplitterAppearance(ASplitter: TTMSFNCSplitter; APrimaryColor: TTMSFNCGraphicsColor = EDITORPRIMCOLOR; ABackGroundColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR);
procedure SetEditorFNCPageControlAppearance(APageControl: TTMSFNCPageControl; APrimaryColor: TTMSFNCGraphicsColor = EDITORPRIMCOLOR; ARounding: integer = EDITORBUTTONROUNDING; AFontColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR; ABackGroundColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR);
procedure SetEditorFNCPageAppearance(APage: TTMSFNCPageControlPage; APrimaryColor: TTMSFNCGraphicsColor = EDITORPRIMCOLOR; ARounding: integer = EDITORBUTTONROUNDING; AFontColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR; ABackGroundColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR);
procedure SetEditorFNCCheckBoxAppearance(ACheckBox: TTMSFNCCheckBox; AFontColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR; ABackgroundColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR);
procedure SetEditorFNCGridAppearance(AGrid: TTMSFNCGrid; APrimaryColor: TTMSFNCGraphicsColor = EDITORPRIMCOLOR; AFontColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR; ABackGroundColor: TTMSFNCGraphicsColor = EDITORAUTOCOLOR);

implementation
uses
  WEBLib.TMSFNCGraphics, WEBLib.TMSFNCUtils
  , Math, SysUtils
  {$IFDEF FMXLIB}
  , FMX.Types
  {$ENDIF}
  ;

procedure SetEditorHTMLTextAppearance(AHTMLText: TTMSFNCHTMLText; AFontColor: TTMSFNCGraphicsColor; ABackGroundColor: TTMSFNCGraphicsColor);
begin
  if Assigned(AHTMLText) then
  begin
    if AFontColor = EDITORAUTOCOLOR then
    begin
      if IsLightTheme then
        AHTMLText.Font.Color := EDITORFONTCOLORLIGHT
      else
        AHTMLText.Font.Color := EDITORFONTCOLORDARK;
    end
    else
      AHTMLText.Font.Color := AFontColor;

  {$IFDEF CMNLIB}
  if ABackGroundColor = EDITORAUTOCOLOR then
  begin
    if IsLightTheme then
    begin
      AHTMLText.Color := EDITORMAINBACKCOLORLIGHT;
    end
    else
    begin
      AHTMLText.Color := EDITORMAINBACKCOLORDARK;
    end;
  end
  else
  begin
    AHTMLText.Color := ABackGroundColor;
  end;
  {$ENDIF}
  {$IFNDEF CMNLIB}
    AHTMLText.Color := ABackGroundColor;
  {$ENDIF}
  end;
end;

procedure SetEditorToolBarAppearance(AToolBar: TTMSFNCToolBar; APrimaryColor: TTMSFNCGraphicsColor; ARounding: integer; AFontColor: TTMSFNCGraphicsColor; ABackGroundColor: TTMSFNCGraphicsColor);
var
  I: Integer;
  tb: TTMSFNCToolBarButton;
  ddb: TTMSFNCToolBarDropDownButton;
  fc: TTMSFNCGraphicsColor;
  lt: boolean;
begin
  if AFontColor = EDITORAUTOCOLOR then
  begin
    if IsLightTheme then
      fc := EDITORFONTCOLORLIGHT
    else
      fc := EDITORFONTCOLORDARK;
  end
  else
    fc := AFontColor;

  lt := IsLightTheme;

  {$IFDEF CMNLIB}
  if ABackGroundColor = EDITORAUTOCOLOR then
  begin
    if lt then
    begin
      AToolBar.Color := EDITORMAINBACKCOLORLIGHT;
    end
    else
    begin
      AToolBar.Color := EDITORMAINBACKCOLORDARK;
    end;
  end
  else
  begin
    AToolBar.Color := ABackGroundColor;
  end;
  {$ENDIF}

  {$IFDEF FMXLIB}
  for I := 0 to AToolBar.ControlCount - 1 do
  {$ENDIF}  
  {$IFNDEF FMXLIB}
  for I := 0 to AToolBar.ControlCount - 1 do
  {$ENDIF}
  begin
    if (AToolBar.Controls[I] is TTMSFNCToolBarButton) then
    begin
      tb := (AToolBar.Controls[I] as TTMSFNCToolBarButton);

      tb.Appearance.FlatStyle := False;

      tb.Appearance.Rounding := 0;
      tb.Appearance.ShowInnerStroke := False;

      tb.Appearance.DisabledStroke.Kind := gskNone;

      {$IFNDEF VCLLIB}
      tb.Appearance.DisabledFill.Kind := gfkNone;
      tb.Appearance.NormalFill.Kind := gfkNone;
      {$ENDIF}
      {$IFDEF VCLLIB}
      tb.Appearance.Transparent := False;
      tb.Appearance.DisabledFill.Kind := gfkSolid;
      tb.Appearance.DisabledFill.Color := AToolBar.Color;
      tb.Appearance.NormalFill.Kind := gfkSolid;
      tb.Appearance.NormalFill.Color := AToolBar.Color;
      tb.Appearance.NormalStroke.Kind := gskSolid;
      tb.Appearance.NormalStroke.Color := AToolBar.Color;

      {$ENDIF}

      tb.Appearance.HoverFill.Kind := gfkSolid;
      tb.Appearance.HoverStroke.Kind := gskSolid;
      tb.Appearance.HoverStroke.Color := APrimaryColor;
      tb.Appearance.HoverFill.Kind := gfkNone;

      tb.Appearance.DownStroke.Kind := gskSolid;
      tb.Appearance.DownFill.Kind := gfkSolid;
      tb.Appearance.DownStroke.Color := APrimaryColor;
      tb.Appearance.DownFill.Color := EditorDarkerShadeColor(APrimaryColor);

      if (tb.GetDropDownButtonControl <> nil) and (tb.GetDropDownButtonControl.Visible) then
      begin

        tb.Appearance.NormalFill.Kind := gfkSolid;
        tb.Appearance.NormalStroke.Kind := gskSolid;
        tb.Appearance.NormalStroke.Color := fc;
        ddb := tb.GetDropDownButtonControl;

        ddb.appearance.ShowInnerStroke := False;

        ddb.Appearance.NormalStroke.Color := fc;
        ddb.Appearance.DisabledStroke.Kind := gskNone;
        ddb.Appearance.DisabledFill.Kind := gfkNone;

        ddb.Appearance.HoverStroke.Color := APrimaryColor;
        ddb.Appearance.DownStroke.Color := APrimaryColor;
        ddb.Appearance.HoverFill.Kind := gfkSolid;
        ddb.Appearance.DownFill.Color := EditorDarkerShadeColor(APrimaryColor);

        ddb.Appearance.NormalFill.Kind := gfkSolid;
        ddb.Appearance.HoverFill.Kind := gfkSolid;
        ddb.Appearance.DownFill.Kind := gfkSolid;

        if ABackGroundColor = EDITORAUTOCOLOR then
        begin
          if lt then
          begin
            tb.Appearance.NormalFill.Color := EDITORSUBBACKCOLORLIGHT;
            ddb.Appearance.NormalFill.Color := EDITORSUBBACKCOLORLIGHT;
            ddb.Appearance.HoverFill.Color := EDITORMAINBACKCOLORLIGHT;
          end
          else
          begin
            tb.Appearance.NormalFill.Color := EDITORSUBBACKCOLORDARK;
            ddb.Appearance.NormalFill.Color := EDITORSUBBACKCOLORDARK;
            ddb.Appearance.HoverFill.Color := EDITORMAINBACKCOLORDARK;
          end;
        end
        else
        begin
          tb.Appearance.NormalFill.Color := ABackGroundColor;
          ddb.Appearance.NormalFill.Color := ABackGroundColor;
          ddb.Appearance.HoverFill.Color := ABackGroundColor;
        end;
      end
      else
      begin
      {$IFNDEF VCLLIB}
        tb.Appearance.NormalFill.Kind := gfkNone;
        tb.Appearance.NormalStroke.Kind := gskNone;
      {$ENDIF}
      end;
      tb.Font.Color := fc;
    end
    else if (AToolBar.Controls[I] is TTMSFNCToolBarSeparator) then
    begin
      (AToolBar.Controls[I] as TTMSFNCToolBarSeparator).Appearance.Stroke.Color := ABackGroundColor;
      (AToolBar.Controls[I] as TTMSFNCToolBarSeparator).Appearance.InnerStroke.Color := fc;
    end;
  end;
end;

procedure SetEditorFNCSplitterAppearance(ASplitter: TTMSFNCSplitter; APrimaryColor: TTMSFNCGraphicsColor; ABackGroundColor: TTMSFNCGraphicsColor);
begin
  if Assigned(ASplitter) then
  begin
    if ABackGroundColor = EDITORAUTOCOLOR then
    begin
      if IsLightTheme then
      begin
        ASplitter.Appearance.SplitterFill.Color := EDITORMAINBACKCOLORLIGHT;
      end
      else
      begin
        ASplitter.Appearance.SplitterFill.Color := EDITORMAINBACKCOLORDARK;
      end;
    end
    else
      ASplitter.Appearance.SplitterFill.Color := ABackGroundColor;

    if IsLightTheme then
    begin
      ASplitter.Appearance.SplitterHoverFill.Color := EDITORSUBBACKCOLORLIGHT;
      ASplitter.Appearance.SplitterDownFill.Color := EDITORSUBBACKCOLORLIGHT;
    end
    else
    begin
      ASplitter.Appearance.SplitterHoverFill.Color := EDITORSUBBACKCOLORDARK;
      ASplitter.Appearance.SplitterDownFill.Color := EDITORSUBBACKCOLORDARK;
    end;

    ASplitter.Appearance.SplitterHoverFill.Color := EDITORPRIMCOLOR;
    ASplitter.Appearance.SplitterDownFill.Color := EDITORPRIMCOLOR;
  end;
end;

procedure SetEditorFNCPageControlAppearance(APageControl: TTMSFNCPageControl; APrimaryColor: TTMSFNCGraphicsColor; ARounding: integer; AFontColor: TTMSFNCGraphicsColor; ABackGroundColor: TTMSFNCGraphicsColor);
var
  dc, fc: TTMSFNCGraphicsColor;
begin
  if Assigned(APageControl) then
  begin
    if AFontColor = EDITORAUTOCOLOR then
    begin
      if IsLightTheme then
        fc := EDITORFONTCOLORLIGHT
      else
        fc := EDITORFONTCOLORDARK;
    end
    else
      fc := AFontColor;

    {$IFNDEF VCLLIB}
    APageControl.Fill.Kind := gfkNone;
    APageControl.Stroke.Kind := gskNone;
    {$ENDIF}
    {$IFDEF VCLLIB}
    APageControl.Fill.Kind := gfkSolid;
    APageControl.Stroke.Kind := gskSolid;

    if ABackGroundColor = EDITORAUTOCOLOR then
    begin
      if IsLightTheme then
      begin
        APageControl.Fill.Color := EDITORSUBBACKCOLORLIGHT;
        APageControl.Stroke.Color := EDITORSUBBACKCOLORLIGHT;
      end
      else
      begin
        APageControl.Fill.Color := EDITORSUBBACKCOLORDARK;
        APageControl.Stroke.Color := EDITORSUBBACKCOLORDARK;
      end;
    end
    else
    begin
      APageControl.Fill.Color := ABackGroundColor;
      APageControl.Stroke.Color := ABackGroundColor;
    end;
    {$ENDIF}

    APageControl.TabAppearance.Fill.Color := ABackGroundColor;
    APageControl.TabAppearance.TextColor := fc;
    APageControl.TabAppearance.Stroke.Color := ABackGroundColor;
    APageControl.TabAppearance.HoverFill.Color := ABackGroundColor;
    APageControl.TabAppearance.HoverStroke.Color := APrimaryColor;
    APageControl.TabAppearance.HoverTextColor := APrimaryColor;

    APageControl.TabAppearance.DownTextColor := gcWhite;
    APageControl.TabAppearance.DownStroke.Color := APrimaryColor;
    dc := EditorLighterShadeColor(APrimaryColor);
    APageControl.TabAppearance.DownFill.Color := dc;

    APageControl.TabAppearance.ActiveTextColor := gcWhite;

    APageControl.TabAppearance.ActiveFill.Kind := gfkGradient;
    APageControl.TabAppearance.ActiveFill.Color := APrimaryColor;
    APageControl.TabAppearance.ActiveFill.ColorTo := EditorDarkerShadeColor(APrimaryColor);

    APageControl.TabAppearance.ActiveStroke.Kind := gskNone;

    APageControl.TabAppearance.Shape := tsRound;
    APageControl.TabAppearance.ShapeOverlap := 0;
  end;
end;

procedure SetEditorFNCPageAppearance(APage: TTMSFNCPageControlPage; APrimaryColor: TTMSFNCGraphicsColor; ARounding: integer; AFontColor: TTMSFNCGraphicsColor; ABackGroundColor: TTMSFNCGraphicsColor);
begin
  APage.UseDefaultAppearance := True;

  APage.Container.Fill.Kind := gfkSolid;
  APage.Container.Stroke.Kind := gskSolid;

  if ABackGroundColor = EDITORAUTOCOLOR then
  begin
    if IsLightTheme then
    begin
      APage.Container.Fill.Color := EDITORSUBBACKCOLORLIGHT;
      APage.Container.Stroke.Color := EDITORSUBBACKCOLORLIGHT;
    end
    else
    begin
      APage.Container.Fill.Color := EDITORSUBBACKCOLORDARK;
      APage.Container.Stroke.Color := EDITORSUBBACKCOLORDARK;
    end;
  end
  else
  begin
    APage.Container.Fill.Color := ABackGroundColor;
    APage.Container.Stroke.Color := ABackGroundColor;
  end;
end;

procedure SetEditorFNCCheckBoxAppearance(ACheckBox: TTMSFNCCheckBox; AFontColor: TTMSFNCGraphicsColor; ABackgroundColor: TTMSFNCGraphicsColor);
begin
  if Assigned(ACheckBox) then
  begin
      if AFontColor = EDITORAUTOCOLOR then
    begin
      if IsLightTheme then
        ACheckBox.Font.Color := EDITORFONTCOLORLIGHT
      else
        ACheckBox.Font.Color := EDITORFONTCOLORDARK;
    end
    else
      ACheckBox.Font.Color := AFontColor;

    if ABackGroundColor = EDITORAUTOCOLOR then
    begin
      if IsLightTheme then
        ACheckBox.Color := EDITORSUBBACKCOLORLIGHT
      else
        ACheckBox.Color := EDITORSUBBACKCOLORDARK;
    end
    else
      ACheckBox.Color := ABackGroundColor;
  end;
end;

procedure SetEditorToolBarButtonAppearance(AButton: TTMSFNCToolBarButton; APrimaryColor: TTMSFNCGraphicsColor; ARounding: integer; AFontColor: TTMSFNCGraphicsColor; ABackGroundColor: TTMSFNCGraphicsColor);
var
  fc{$IFDEF VCLLIB}, bc{$ENDIF}: TTMSFNCGraphicsColor;
  ddb: TTMSFNCToolBarDropDownButton;
begin
  if Assigned(AButton) then
  begin
    if AFontColor = EDITORAUTOCOLOR then
    begin
      if IsLightTheme then
        fc := EDITORFONTCOLORLIGHT
      else
        fc := EDITORFONTCOLORDARK;
    end
    else
      fc := AFontColor;

    AButton.Appearance.FlatStyle := False;

    AButton.Appearance.Rounding := ARounding;
    AButton.Appearance.ShowInnerStroke := False;

    AButton.Appearance.DisabledStroke.Kind := gskNone;

    {$IFNDEF VCLLIB}
    AButton.Appearance.DisabledFill.Kind := gfkNone;
    AButton.Appearance.NormalFill.Kind := gfkNone;
    AButton.Appearance.HoverStroke.Kind := gskSolid;
    AButton.Appearance.HoverStroke.Color := APrimaryColor;
    AButton.Appearance.HoverFill.Kind := gfkNone;
    {$ENDIF}
    {$IFDEF VCLLIB}
    if ABackGroundColor = EDITORAUTOCOLOR then
    begin
      if IsLightTheme then
        bc := EDITORSUBBACKCOLORLIGHT
      else
        bc := EDITORSUBBACKCOLORDARK;
    end
    else
      bc := ABackGroundColor;

    AButton.Appearance.Transparent := False;
    AButton.Appearance.DisabledFill.Kind := gfkSolid;
    AButton.Appearance.DisabledFill.Color := bc;
    AButton.Appearance.NormalFill.Kind := gfkSolid;
    AButton.Appearance.NormalFill.Color := bc;
    AButton.Appearance.NormalStroke.Kind := gskSolid;
    AButton.Appearance.NormalStroke.Color := bc;

    AButton.Appearance.HoverFill.Kind := gfkSolid;
    AButton.Appearance.HoverFill.Color := bc;
    AButton.Appearance.HoverStroke.Kind := gskSolid;
    AButton.Appearance.HoverStroke.Color := APrimaryColor;
    {$ENDIF}

    AButton.Appearance.DownStroke.Kind := gskSolid;
    AButton.Appearance.DownFill.Kind := gfkSolid;
    AButton.Appearance.DownStroke.Color := APrimaryColor;
    AButton.Appearance.DownFill.Color := EditorDarkerShadeColor(APrimaryColor);

    if (AButton.GetDropDownButtonControl <> nil) and (AButton.GetDropDownButtonControl.Visible) then
    begin

      AButton.Appearance.NormalFill.Kind := gfkSolid;
      AButton.Appearance.NormalStroke.Kind := gskSolid;
      AButton.Appearance.NormalStroke.Color := fc;
      ddb := AButton.GetDropDownButtonControl;

      ddb.appearance.ShowInnerStroke := False;

      ddb.Appearance.NormalStroke.Color := fc;
      ddb.Appearance.DisabledStroke.Kind := gskNone;
      ddb.Appearance.DisabledFill.Kind := gfkNone;

      ddb.Appearance.HoverStroke.Color := APrimaryColor;
      ddb.Appearance.DownStroke.Color := APrimaryColor;
      ddb.Appearance.HoverFill.Kind := gfkSolid;
      ddb.Appearance.DownFill.Color := EditorDarkerShadeColor(APrimaryColor);

      ddb.Appearance.NormalFill.Kind := gfkSolid;
      ddb.Appearance.HoverFill.Kind := gfkSolid;
      ddb.Appearance.DownFill.Kind := gfkSolid;

      if ABackGroundColor = EDITORAUTOCOLOR then
      begin
        if IsLightTheme then
        begin
          AButton.Appearance.NormalFill.Color := EDITORSUBBACKCOLORLIGHT;
          ddb.Appearance.NormalFill.Color := EDITORSUBBACKCOLORLIGHT;
          ddb.Appearance.HoverFill.Color := EDITORMAINBACKCOLORLIGHT;
        end
        else
        begin
          AButton.Appearance.NormalFill.Color := EDITORSUBBACKCOLORDARK;
          ddb.Appearance.NormalFill.Color := EDITORSUBBACKCOLORDARK;
          ddb.Appearance.HoverFill.Color := EDITORMAINBACKCOLORDARK;
        end;
      end
      else
      begin
        AButton.Appearance.NormalFill.Color := ABackGroundColor;
        ddb.Appearance.NormalFill.Color := ABackGroundColor;
        ddb.Appearance.HoverFill.Color := ABackGroundColor;
      end;
    end
    else
    begin
    {$IFNDEF VCLLIB}
      AButton.Appearance.NormalFill.Kind := gfkNone;
      AButton.Appearance.NormalStroke.Kind := gskNone;
    {$ENDIF}
    end;
    AButton.Font.Color := fc;
  end;
end;

procedure SetEditorFNCGridAppearance(AGrid: TTMSFNCGrid; APrimaryColor: TTMSFNCGraphicsColor; AFontColor: TTMSFNCGraphicsColor; ABackGroundColor: TTMSFNCGraphicsColor);
var
  ffc, bc, fc: TTMSFNCGraphicsColor;
begin
  if Assigned(AGrid) then
  begin
    if AFontColor = EDITORAUTOCOLOR then
    begin
      if IsLightTheme then
        fc := EDITORFONTCOLORLIGHT
      else
        fc := EDITORFONTCOLORDARK;
    end
    else
      fc := AFontColor;

    if ABackGroundColor = EDITORAUTOCOLOR then
    begin
      if IsLightTheme then
        bc := EDITORMAINBACKCOLORLIGHT
      else
        bc := EDITORMAINBACKCOLORDARK;
    end
    else
      bc := ABackGroundColor;
    if IsLightTheme then
    begin
      ffc := EDITORSUBBACKCOLORLIGHT;
    end
    else
    begin
      ffc := EDITORSUBBACKCOLORDARK;
    end;

    AGrid.Fill.Kind := gfkSolid;
    AGrid.Fill.Color := bc;

    AGrid.GlobalFont.Color := fc;

    AGrid.Appearance.FixedLayout.Fill.Color := ffc;
    AGrid.Appearance.FixedLayout.Font.Color := fc;
    AGrid.Stroke.Color := ffc;

    AGrid.Appearance.SelectedLayout.Fill.Color := APrimaryColor;
    AGrid.Appearance.SelectedLayout.Font.Color := gcWhite;
    AGrid.Appearance.FocusedLayout.Fill.Color := APrimaryColor;
    AGrid.Appearance.FocusedLayout.Font.Color := gcWhite;
  end;
end;

end.
